import { Helmet } from 'react-helmet-async';
import GseaRanked from '../modules/gseaRanked/GseaRanked';
import NotFoundContent from './NotFound';
import { isGseaEnabled } from '../modules/enrichment/helpers';

export default function GseaRankedPage() {
  if (!isGseaEnabled) {
    return <NotFoundContent />;
  }

  return (
    <>
      <Helmet>
        <title>DISGENET: GSEA (Ranked Gene List)</title>
        <meta
          name="description"
          content="Perform Gene Set Enrichment Analysis (GSEA) on a ranked gene list with DISGENET."
        />
      </Helmet>
      <div className="advanced-research container-view md:p-4">
        <div className="search-results-container">
          <GseaRanked />
        </div>
      </div>
    </>
  );
}
